import { render, staticRenderFns } from "./FeatureChapter.vue?vue&type=template&id=527977bc&"
import script from "./FeatureChapter.vue?vue&type=script&lang=js&"
export * from "./FeatureChapter.vue?vue&type=script&lang=js&"
import style0 from "./FeatureChapter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports